import { forwardRef } from "react";
import {
  Link as MuiLink,
  LinkProps as MuiLinkProps,
  makeStyles,
  createStyles,
  Theme,
} from "@material-ui/core";
import { Link as RouterLink, LinkProps as RouterLinkProps } from "react-router-dom";

type LinkProps = {} & MuiLinkProps & RouterLinkProps;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      color: "inherit",
      fontFamily: [
        "Lota Grotesque",
        "BlinkMacSystemFont",
        '"Segoe UI"',
        "Roboto",
        '"Helvetica Neue"',
        "Arial",
        "sans-serif",
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(","),

      "&:hover": {
        textDecoration: "none",
      },
    },
  }),
);

export const Link = forwardRef((props: LinkProps, ref: any) => {
  const classes = useStyles();

  return <MuiLink component={RouterLink} className={classes.root} {...props} ref={ref} />;
});
